import { ComponentFactoryResolver, ComponentRef, Injectable, Injector, NgModuleRef, Type, ViewContainerRef } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { BottomPopupComponent } from './bottom-popup.component';
import { MapService } from '@accounts/user/services/map.service';

export interface BottomPopupData {
  headerText?: string;
  height?: number;
  minHeight?: number;
  maxHeight?: number;
}

@Injectable({
  providedIn: 'root'
})
export class BottomPopupService {

  constructor(
    private bottomSheet: MatBottomSheet,
    private mapService: MapService
  ) { }

  _ref: MatBottomSheetRef;
  open(childComponent: any, data?: BottomPopupData) {
    this._ref = this.bottomSheet.open(BottomPopupComponent, {
      panelClass: 'bottom-popup-hidden'
    });
    this._ref.instance.headerText = data.headerText;
    this._ref.instance.height = data.height;
    this._ref.instance.maxHeight = data.maxHeight;
    this._ref.instance.minHeight = data.minHeight || 300;
    this._ref.instance.childTemplate = childComponent;
    this._ref.instance.mbsRefference = this._ref;
    
    // Trigger map bounds change to fix positioning and enable click events in Mozilla
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      
      // Directly trigger map bounds change if map exists
      if (this.mapService.map) {
        this.mapService.map.container.fitToViewport();
      }
      
      // Remove the hidden class to show the modal
      const container = document.querySelector('.bottom-popup-hidden.mat-bottom-sheet-container') as HTMLElement;
      if (container) {
        container.classList.remove('bottom-popup-hidden');
        container.classList.add('bottom-popup-visible');
      }
    }, 10);
  }

  close(){
    if(this._ref){
      this._ref.dismiss();
    }
  }
}